import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { AUTH_TOKEN_KEY, USER_STORAGE_KEY } from '../constants/storageKeys';

// Configuração base da API
const getApiBaseUrl = (): string => {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  // Remover barra final se existir e adicionar /api
  const normalized = baseUrl.replace(/\/$/, '');
  // Se já contém /api, não adicionar novamente
  if (normalized.endsWith('/api')) {
    return normalized;
  }
  return `${normalized}/api`;
};

const API_BASE_URL = getApiBaseUrl();

// Criar instância do axios
const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de resposta
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const requestUrl = error.config?.url ?? '';
    const isAuthAttempt =
      requestUrl.includes('/auth/login') ||
      requestUrl.includes('/auth/register') ||
      requestUrl.includes('/auth/logout');

    // Tratar erro de autenticação
    if (error.response?.status === 401 && !isAuthAttempt) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      localStorage.removeItem(USER_STORAGE_KEY);
      window.location.href = '/login';
    }

    // Tratar outros erros
    const data = error.response?.data as unknown
    let errorMessage = 'Ocorreu um erro. Tente novamente.'
    
    if (data && typeof data === 'object') {
      // Se for erro de validação do NestJS (tem message como array ou string)
      const validationMessage = (data as { message?: string | string[] }).message
      if (Array.isArray(validationMessage)) {
        errorMessage = validationMessage.join(', ')
      } else if (typeof validationMessage === 'string') {
        errorMessage = validationMessage
      } else {
        // Tentar pegar mensagem de error como fallback
        const maybeError = (data as { error?: string }).error
        if (maybeError) {
          errorMessage = maybeError
        }
      }
    }

    return Promise.reject({
      ...error,
      status: error.response?.status,
      message: errorMessage,
      response: error.response,
      data: error.response?.data,
    });
  }
);

export default api;

